module.exports = __webpack_public_path__ + "static/img/MQ.50fc580b.svg";